
import React, { useState, useEffect } from 'react';

import axios2 from '../services/axios2';
import { ToastContainer, toast } from 'react-toastify';

// eslint-disable-next-line import/no-anonymous-default-export
const Dashboard =()=>{

  const initialFormState= {
    
    cn_doc: 0,
    cn_est: 0,
    cn_carre: 0,
    cn_mate:0
  }
  //--state
  const [form, setForm] = useState(initialFormState);
  //--------cargamos los valores desde el server -----------
  //---equivalente a component did mount
  useEffect(() => {
    console.log("I have been mounted")
    cargarDatos();
  }, []);
  //======================================================
  const cargarDatos = () => {
    
    const param = {
    };
    console.log( process.env.API_URL + "dashboard_get_tot");
    axios2.post( process.env.REACT_APP_API_URL  + "dashboard_get_tot",param)
          .then(res => {
            let response = res.data;
            console.log(response)
            
            setForm(response);

            toast.info("Cargado con éxito");

            /*toast.error("Error Notification !", {
              position: toast.POSITION.TOP_LEFT
            });*/
            
          })
          .catch(err => {
            console.log("err->");
            console.log(err)
          });  
      
  };
  //----------------------------------------------------
  //--------------------------------------------------------
  return(
    <div className="content">
      <ToastContainer />
      {
        //JSON.stringify( form )
      }
      <div className="row">
        <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
          <div className="dash-widget">
            <span className="dash-widget-bg1"><i className="fa fa-user" aria-hidden="true"></i></span>
            <div className="dash-widget-info text-right">
              <h3>{form.cn_doc} </h3>
              <span className="widget-title1">Docentes <i className="fa fa-check" aria-hidden="true"></i></span>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
          <div className="dash-widget">
            <span className="dash-widget-bg2"><i className="fa fa-user-o"></i></span>
            <div className="dash-widget-info text-right">
              <h3>{form.cn_est}</h3>
              <span className="widget-title2">Estudiantes <i className="fa fa-check" aria-hidden="true"></i></span>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
          <div className="dash-widget">
            <span className="dash-widget-bg3"><i className="fa fa-line-chart" aria-hidden="true"></i></span>
            <div className="dash-widget-info text-right">
              <h3>{form.cn_carre}</h3>
              <span className="widget-title3">Carreras <i className="fa fa-check" aria-hidden="true"></i></span>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
          <div className="dash-widget">
            <span className="dash-widget-bg4"><i className="fa fa-file-text" aria-hidden="true"></i></span>
            <div className="dash-widget-info text-right">
              <h3>{form.cn_mate}</h3>
              <span className="widget-title4">Materias<i className="fa fa-check" aria-hidden="true"></i></span>
            </div>
          </div>
        </div>
      </div>

      {/* /.col */}
    </div>
  );

}

export default Dashboard;